function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h2',[_vm._v("Tell us about your business")]),_vm._v(" "),_c('p',[_vm._v("See our web form tracking in action. WhiteBox attaches to web forms and monitors when they're submitted. User inquiry information interactions is live in your browser. Try it!")]),_vm._v(" "),_c('p',[_vm._v("*"),_c('em',[_vm._v("Note, this is just a demo. We won't contact you back at this stage.")])])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/interactions/forms/details","customers":"Where do you meet your customers?","company":"Company name","frontdesk":"Front desk","storefront":"Storefront","callCenter":"Call center","online":"Online","spend":"What is you monthly advertising budget?","spendOptions":["Up to €1000","Between €1000 and €5000","Above €5000"],"send":"Send","subject":"Business survey","message":"Company name: {{company}}{{#each customers}} • {{ . }}{{/each}}; Monthly advertising budget: {{spend}}"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }